<template>
  <div v-if="categories" class="vz-cargo-categories-view">
    <div v-if="categories.cargoCategoryName" class="vz-cargo-view-item">
      <div class="vz-cargo-view-item-title">
        Категория груза
      </div>
      <span class="vz-cargo-view-item-list">{{ categories.cargoCategoryName }}</span>
    </div>

    <template v-if="wrapping">
      <div v-for="({ codeTitle, places }, i) in wrapping" :key="i" class="mt-10">
        <div class="vz-cargo-view-item-title">
          Упаковка {{ i + 1 }}
        </div>
        <div class=" vz-cargo-view-item-list">
          Вид упаковки: {{ codeTitle }}
        </div>
        <div v-if="places" class="vz-cargo-view-item-list">
          Места: {{ places }}
        </div>
      </div>
    </template>

    <div class="flex mt-10">
      <div class="flex flex-column w-100">
        <div v-if="categories.insurance" class="w-50 vz-cargo-view-item">
          <div class="vz-cargo-view-item-title">
            Страхование
          </div>
          <span class="vz-cargo-view-item-list">{{ insuranceText }}</span>
        </div>

        <div v-if="order.meta?.marketplace?.name" class="w-50 vz-cargo-view-item">
          <div class="vz-cargo-view-item-title">
            Маркетплейс
          </div>
          <span class="vz-cargo-view-item-list">{{ order.meta.marketplace.name }}</span>
        </div>
      </div>

      <div v-if="categories.insuranceCost" class="w-50 vz-cargo-view-item">
        <div class="vz-cargo-view-item-title">
          Сумма
        </div>
        <span class="vz-cargo-view-item-value">{{ categories.insuranceCost }} ₽</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {OrderForm, OrderView} from '~/types/types';
import {useWrappingStore, WrappingCode} from "~/stores/wrapping"
import {PropType} from 'vue';

const props = defineProps({
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  }
})

const wrappingStore = useWrappingStore()
const categories = computed((): { cargoCategoryName: string, insurance: string, insuranceCost: number } => {
  const orderForm = props.order as OrderView
  return {
    cargoCategoryName: orderForm.cargo.categoryName,
    insurance: orderForm.cargo.insurance.type,
    insuranceCost: orderForm.cargo.insurance.value
  }
})

const wrapping = computed((): { codeTitle: string, places?: string }[] => {
  if (props.order.cargo.mode === 'parcels') {
    return []
  }
  if (props.order.cargo.mode === 'dimension') {
    return Object.entries(props.order.cargo.dimensions.wrapping).map(([, data]) => {
      return {
        codeTitle: getCodeTitle(data.code, data.value)
      }
    })
  }

  const items = props.order.cargo[props.order.cargo.mode].items
  const codes: string[] = []
  let places: any
  items.forEach((item) => {
    item.wrapping.forEach((i) => {
      if (!codes.includes(i.code)) {
        codes.push(i.code)
      }
    })
  })

  return codes.map((code) => {
    places = []
    let v = 0
    items.forEach((item, index) => {
      const findWrapping: any = item.wrapping.find(i => i.code === code)
      if (findWrapping) {
        places.push(item.label || `${modeWrappingTitle.value} ${index + 1}`)
        v = findWrapping.value
      }
    })
    return {
      codeTitle: getCodeTitle(code, v),
      places: places.join(', ')
    }
  })
})

const modeWrappingTitle = computed((): string => {
  switch (props.order.cargo.mode) {
    case 'pallets':
      return 'Паллета'
    case 'parcels':
      return 'Посылка'
    default:
      return 'Груз'
  }
})

const insuranceText = computed((): string => {
  switch (categories.value?.insurance) {
    case 'cargoInsurance':
      return 'Страхование'
    case 'noDeclaredValue':
      return 'Без объявленной стоимости'
    case 'without':
      return 'Без страхования'
    default:
      return 'Без объявленной стоимости'
  }
})

function getCodeTitle(code: WrappingCode, value?: number): string {
  let title: string
  const names: string[] = []
  const codeWrapping = wrappingStore.getWrappingByCode(code)

  if (codeWrapping?.groupName) {
    names.push(codeWrapping?.groupName)
  }
  if (codeWrapping?.name) {
    names.push(codeWrapping.name)
  }
  title = names.join(', ')
  if (codeWrapping?.type === 'numeric') {
    title += ` ${value} шт.`
  }
  return title
}
</script>

<style lang="scss" scoped>
.vz-cargo-categories-view {
  &-item {
    &--title {
      font-weight: 500;
      margin-bottom: 4px;
    }
  }
}
</style>
